import { render, staticRenderFns } from "./MarginManage.vue?vue&type=template&id=70905aab&scoped=true&"
import script from "./MarginManage.vue?vue&type=script&lang=js&"
export * from "./MarginManage.vue?vue&type=script&lang=js&"
import style0 from "./MarginManage.vue?vue&type=style&index=0&id=70905aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70905aab",
  null
  
)

export default component.exports